import {
    Heading,
    Button,
    View,
    Flex,
} from "@aws-amplify/ui-react";
import { API, Auth } from "aws-amplify";

export function BrandCookbook({
    balance,
    updateBalance,
    subscription,
    clientData,
}) {
    async function handleBrandCookbookButtonClick() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const subject = `BrandCookbook button clicked by ${clientData?.email || "unknown"}`;
            const body = [
                `BrandCookbook button clicked by ${clientData?.email || "unknown"}`,
                `subscriptionPlan: ${clientData?.subscriptionPlan || "N/A"}`,
                `payments: ${clientData?.payments || "N/A"}`,
                `fiatBalance: ${clientData?.fiatBalance || 0}`,
                `subscriptionId: ${clientData?.subscriptionId || "N/A"}`,
            ].join("\n");

            const request = {
                headers: {
                    Authorization: `${user.signInUserSession.idToken.jwtToken}`,
                },
                body: { subject, body },
            };
            await API.post("gcAPI", "/send-email", request);
            //console.log("Admin email sent successfully from BrandCookbook");
        } catch (error) {
            //console.error("Error sending email from BrandCookbook:", error);
        }
    }

    return (
        <>
            <View align="center">
                <View maxWidth="1000px" align="left">
                    <Heading
                        level={3}
                        fontWeight={"bold"}
                        textAlign="center"
                        color={"#414c5a"}
                        style={{ lineHeight: "1.5" }}
                    >
                        Brand Cookbook
                        <br />
                        <br />
                    </Heading>

                    <Flex
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        marginBottom="20px"
                    >
                        <br />
                        Guides for Brands on how to get the most out of the system.
                        <br />
                        <Button
                            variation="primary"
                            size="large"
                            style={{
                                marginBottom: "10px",
                                padding: "20px 40px",
                            }}
                            onClick={handleBrandCookbookButtonClick}
                        >
                            Coming Soon!
                        </Button>
                        <br />
                    </Flex>
                </View>
            </View>
        </>
    );
}
